.researchConsentContainer {
  margin-top: 1em;
}

.label {
  font-weight: bold !important;
  font-size: 1em !important;
}
